module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/error.65d70633.svg";